function _(o, {
  anchor: t,
  popup: e,
  boundingRect: i
}) {
  const s = (e.height - t.height) / 2, h = (e.width - t.width) / 2, P = -(t.left - i.left), n = i.width - (t.left - i.left) - e.width, f = -(t.top - i.top), m = i.height - (t.top - i.top) - e.height;
  switch (o === "auto" ? O({ boundingRect: i, anchor: t }) : o) {
    case "left":
      return {
        top: d({
          minBound: f,
          desired: -s,
          maxBound: m
        }),
        left: -e.width - 8
      };
    case "top":
      return {
        top: -e.height - 8,
        left: d({
          minBound: P,
          desired: -h,
          maxBound: n
        })
      };
    case "right":
      return {
        top: d({
          minBound: f,
          desired: -s,
          maxBound: m
        }),
        left: t.width + 8
      };
    case "bottomRight":
      return {
        top: t.height + 8,
        left: d({
          minBound: P,
          desired: t.width / 2 - 8,
          maxBound: n
        })
      };
    case "bottomLeft":
      return {
        top: t.height + 8,
        left: d({
          minBound: P,
          desired: t.width / 2 - e.width + 8,
          maxBound: n
        })
      };
    case "topRight":
      return {
        top: -e.height - 8,
        left: d({
          minBound: P,
          desired: t.width / 2 - 8,
          maxBound: n
        })
      };
    case "topLeft":
      return {
        top: -e.height - 8,
        left: d({
          minBound: P,
          desired: t.width / 2 - e.width + 8,
          maxBound: n
        })
      };
    case "bottom":
    default:
      return {
        top: t.height + 8,
        left: d({
          minBound: P,
          desired: -h,
          maxBound: n
        })
      };
  }
}
function d({
  minBound: o,
  desired: t,
  maxBound: e
}) {
  return Math.max(o, Math.min(t, e));
}
function O({
  boundingRect: o,
  anchor: t
}) {
  const e = {
    x: t.left + t.width / 2,
    y: t.top + t.height / 2
  }, i = {
    x: o.left + o.width / 2,
    y: o.top + o.height / 2
  };
  return e.x < i.x ? e.y < i.y ? "bottomRight" : "topRight" : e.y < i.y ? "bottomLeft" : "topLeft";
}
export {
  _ as getPopupPosition
};
